import PropTypes from 'prop-types'
import { useContext, useState } from 'react'
import { CarritoContext } from '../../context/carritoContext'
import Imagen from '../../imagen/Imagen'
import { SumarProductos } from '../sumarProductos/SumarProductos'
import styles from './PublicacionSinDetalle.module.css'

export const PublicacionSinDetalle = ({ publicacion }) => {
  const { idPublicacion, titulo, precio, monSimb, cantDisponible } = publicacion
  const [cantidad, setCantidad] = useState(1)
  const { onAgregarCarrito, setVerCarrito, setCantidadCompra } =
    useContext(CarritoContext)

  const incrementar = (e) => {
    e.stopPropagation()
    setCantidad((prev) => (prev < cantDisponible ? prev + 1 : prev))
  }
  const decrementar = (e) => {
    e.stopPropagation()
    setCantidad((prev) => (prev > 1 ? prev - 1 : 1))
  }

  const agregarAlCarrito = (e) => {
    e.stopPropagation()
    setVerCarrito(true)
    onAgregarCarrito(idPublicacion, cantidad)
    setCantidadCompra(1)
    setCantidad(1)
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.containerImagen}>
          <Imagen idPublicacion={idPublicacion} width={70} />
        </div>
        <SumarProductos
          cantidad={cantidad}
          setCantidad={setCantidad}
          decrementar={decrementar}
          incrementar={incrementar}
          cantDisponible={cantDisponible}
          agregarAlCarrito={agregarAlCarrito}
          styles={styles}
        />
      </div>
      <div className={styles.detalleContainer}>
        <p className={styles.titulo}>{titulo}</p>
        <p className={styles.precio}>
          {monSimb}
          {precio.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </p>
      </div>
    </>
  )
}

PublicacionSinDetalle.propTypes = {
  publicacion: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    titulo: PropTypes.string.isRequired,
    precio: PropTypes.number.isRequired,
    monSimb: PropTypes.string.isRequired,
    cantDisponible: PropTypes.number.isRequired
  }).isRequired
}
